var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDollarIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 14 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.829 14.167a6.666 6.666 0 1 1 0-13.333 6.666 6.666 0 0 1 0 13.333M4.495 8.834v1.333h1.667v1.334h1.333v-1.334h.667a1.667 1.667 0 1 0 0-3.333H5.495a.333.333 0 1 1 0-.667h3.667V4.834H7.495V3.501H6.162v1.333h-.667a1.667 1.667 0 0 0 0 3.333h2.667a.333.333 0 0 1 0 .667z"
})));
export { SvgDollarIcon as ReactComponent };
export default __webpack_public_path__ + "e7bc70cdd85a321d81f3176d0cac77e7.svg";